import { render, staticRenderFns } from "./FeeDescription.vue?vue&type=template&id=2b6b1444&scoped=true"
import script from "./FeeDescription.vue?vue&type=script&lang=js"
export * from "./FeeDescription.vue?vue&type=script&lang=js"
import style0 from "./FeeDescription.vue?vue&type=style&index=0&id=2b6b1444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b1444",
  null
  
)

export default component.exports